define('lib/Podio.Tracking',['require','underscore','jquery','jquery.cookie','lib/Podio.Event.UI','lib/Podio.Event','lib/Podio.Config','lib/Podio.Logger','lib/Podio.Utils','models/Podio.Models.User','lib/backbone/Backbone.Mixins.Transport.API'],function (require) {
  var _ = require("underscore");
  var $ = require("jquery");
  require("jquery.cookie");
  var eventUI = require("lib/Podio.Event.UI");
  var podioEvent = require("lib/Podio.Event");
  var podioConfig = require("lib/Podio.Config");
  var podioLogger = require("lib/Podio.Logger");
  var podioUtils = require("lib/Podio.Utils");
  var User = require("models/Podio.Models.User");
  var user = new User();

  var APITransport = require("lib/backbone/Backbone.Mixins.Transport.API");

  var helpers = {
    isSignedIn: function _isSignedIn() {
      return _.has(podioConfig, "user");
    },

    originIsTracked: function _originIsTracked() {
      return _.isString($.cookie("_podio-landing-url"));
    },

    baseDomain: function _baseDomain() {
      if (podioConfig.base_domain) {
        return podioConfig.base_domain;
      } else {
        var hostNameParts = window.location.hostname.split(".");
        return (
          hostNameParts[hostNameParts.length - 2] +
          "." +
          hostNameParts[hostNameParts.length - 1]
        );
      }
    },

    setOriginCookies: function _setOriginCookies(referrer_url, landing_url) {
      var options = { expires: 7, path: "/", domain: helpers.baseDomain() };
      $.cookie("_podio-referrer-url", referrer_url, options);
      $.cookie("_podio-landing-url", landing_url, options);
    },
  };

  function trackUserOrigin() {
    //
    // NOTE: commenting these conditions as we want to correctly track the landing URL
    //       If we see any problem where this cookie impacts we can visit here.

    // if( ! helpers.isSignedIn() && ! helpers.originIsTracked() ) {
    var referrer_url = document.referrer;
    var landing_url = document.location;
    helpers.setOriginCookies(referrer_url, landing_url);
    // }
  }

  function loadScript(url) {
    return $.ajax({
      url: url,
      dataType: "script",
      cache: true,
    });
  }

  function onFloodlightClicked(elmTarget, e) {
    trackFloodlight(elmTarget.attr("data-floodlight"));
  }

  function trackFloodlight(activityName) {
    var activities = {
      Podio_Confirm_Q3: { type: "confi746", cat: "podio232" },
      "Podio_RT_Low-Priority": { type: "rtlow485", cat: "podio519" },
      Podio_Upgrade_Success: { type: "landi122", cat: "upgra888" },
      "Podio_RT_High-Priority": { type: "rthig117", cat: "podio987" },
      Podio_Exclusion_100212: { type: "landi122", cat: "podio983" },
    };

    if (activities[activityName]) {
      var axel = Math.random() + "";
      var a = axel * 10000000000000000;

      var iframe = document.createElement("iframe");
      iframe.src =
        "https://fls.doubleclick.net/activityi;src=3803600;type=" +
        activities[activityName]["type"] +
        ";cat=" +
        activities[activityName]["cat"] +
        ";ord=1;num=" +
        a +
        "?";
      iframe.frameborder = "0";
      iframe.scrolling = "no";
      iframe.width = "1";
      iframe.height = "1";
      iframe.style.visibility = "hidden";
      iframe.style.display = "none";
      iframe.id = "floodlight";
      document.body.appendChild(iframe);
    }
  }

  function onFormSubmitTracking(elmTarget, e) {
    // Avoid double form submissions and double event tracking
    if (elmTarget.data("submission-already-handled")) {
      e.preventDefault();
      return;
    }
    if (
      elmTarget.data("tracking-event-done") ||
      elmTarget.data("submission-already-handled")
    ) {
      return;
    }

    elmTarget.data("submission-already-handled", true);

    function completed() {
      elmTarget.data("submission-already-handled", false);
      if (elmTarget[0].action) {
        elmTarget.submit();
      }
    }
  }

  function trackGroupConversion(type, data) {
    var dfd = new $.Deferred();

    if (type === "google") {
      trackGoogleConversion(dfd, data, 0);
    } else if (type === "bing") {
      trackBingConversion(dfd, data, 0);
    }

    // Make sure deferred is resolved, even if script didnt load;
    _.delay(function () {
      dfd.resolve("");
    }, 1500);

    return dfd;
  }

  function trackBingConversion(dfd, data, index) {
    // See http://stackoverflow.com/questions/12463796/bing-conversion-code-onsubmit-event
    var iframe = document.createElement("iframe");
    iframe.src =
      "//flex.atdmt.com/mstag/tag/" +
      data[0]["url"] +
      "/analytics.html?dedup=1&domainId=" +
      data[0]["domain"] +
      "&type=1&actionid=" +
      data[0]["action"] +
      "";
    iframe.frameborder = "0";
    iframe.scrolling = "no";
    iframe.width = "1";
    iframe.height = "1";
    iframe.style.visibility = "hidden";
    iframe.style.display = "none";
    iframe.id = "bing-conversion";
    document.body.appendChild(iframe);

    $("#bing-conversion").load(function () {
      dfd.resolve("");
    });
  }

  function trackGoogleConversion(dfd, data, index) {
    window.google_conversion_language = "en";
    window.google_conversion_format = "3";
    window.google_conversion_color = "ffffff";
    window.google_conversion_value = 0;

    // Overwride document.write, since Google JS is doing a document.write. See http://articles.adamwrobel.com/2010/12/23/trigger-adwords-conversion-on-javascript-event
    document.write = function (text) {
      $("body").append(text);
    };

    if (!index) {
      index = 0;
    }

    if (data[index]) {
      window.google_conversion_id = data[index][0];
      window.google_conversion_label = data[index][1];
      // Loop over data and convert
      $.getScript(
        "https://www.googleadservices.com/pagead/conversion.js",
        function () {
          // Delay 200ms in case google is slow.
          _.delay(function () {
            index++;
            if (data[index]) {
              trackGoogleConversion(dfd, data, index);
            } else {
              dfd.resolve("");
            }
          }, 200);
        }
      );
    } else {
      dfd.resolve("");
    }
  }

  function onEventTrackingClicked(elmTarget, e) {
    var data = {
      type: elmTarget.data("event-tracking-type"),
      subtype: elmTarget.data("event-tracking-subtype"),
      context_ref_type: elmTarget.data("event-tracking-context-ref-type"),
      context_ref_id: elmTarget.data("event-tracking-context-ref-id"),
      data: elmTarget.data("event-tracking-data"),
    };

    eventTracking(data);
  }

  function eventTracking(data) {
    return APITransport.request("post", "/tracking/event", data);
  }

  function onInit(tracking) {
    trackUserOrigin();

    if (window.initialPodioEventTrackings) {
      var forRemoval = [];
      _.each(window.initialPodioEventTrackings, function (eventTracking, i) {
        if (_.isFunction(eventTracking)) {
          eventTracking(tracking);
          forRemoval.push(eventTracking);
        }
      });

      // Clean up functions that have run
      forRemoval.unshift(window.initialPodioEventTrackings);
      window.initialPodioEventTrackings = _.without.apply(_, forRemoval);

      if (!window.initialPodioEventTrackings.length) {
        window.initialPodioEventTrackings = null;
      }
    }
  }

  var tracking = {
    baseDomain: helpers.baseDomain,
    trackFloodlight: trackFloodlight,
    loadScript: loadScript,
    eventTracking: eventTracking,
  };

  podioEvent.bind(podioEvent.Types.init, onInit.curry(tracking));
  eventUI.bind("click", "*[data-floodlight]", onFloodlightClicked, true);
  eventUI.bind("click", "*[data-event-tracking]", onEventTrackingClicked, true);
  eventUI.bind(
    "submit",
    "form[data-form-event-tracking]",
    onFormSubmitTracking,
    true
  );

  return tracking;
});

